import axios from "axios";
import { artistPageList, musicAlbum, musicArtist, musicDetails, musicGenrePlay, musicHomePageApi, musicPlaylist, musicQueue, musicianPageList, writerPageList, radioStationDetails, adminAudioPlaylistTracks } from "../../components/Api/MusicApi";
import { getItem, getItemToken } from "../../Utils/localStorageUtils";
import { toast } from "react-toastify";
const apiGenerate = (type, chooseobject) => {

    let resultObject;
    switch (type) {
        case 'AUDIO':
        case 'latest_audios':
            resultObject = {
                slug: "audio_slug",
                details: "audios_details",
                playlistdetails: "other_audios",
                artists: "TopArtist",
                api: musicDetails,
                playapi: musicQueue
            };
            break;

        case 'ARTIST':
            resultObject = {
                slug: "artist_slug",
                details: "artistDetails",
                playlistdetails: "artistAudios",
                artists: "TopArtist",
                api: musicArtist,
                playapi: musicArtist,
                pagelistApi: artistPageList

            };
            break;

        case 'PLAYLIST':
            resultObject = {
                slug: "playlist_slug",
                details: "playlist",
                playlistdetails: "data",
                artists: "TopArtist",
                api: musicPlaylist,
                playapi: musicPlaylist
            };
            break;

        case 'ADMIN_PLAYLIST':
            resultObject = {
                slug: "playlist_slug",
                details: "playlist",
                playlistdetails: "data",
                artists: "TopArtist",
                api: adminAudioPlaylistTracks,
                playapi: adminAudioPlaylistTracks
            };
            break;

        case 'ALBUM':
            resultObject = {
                slug: "album_slug",
                details: "album_details",
                playlistdetails: "album_audios",
                artists: "TopAudioAlbum",
                api: musicAlbum,
                playapi: musicAlbum
            };
            break;
        case 'STATION':
            resultObject = {
                slug: "slug",
                details: "radiostation",
                playlistdetails: "data",
                artists: "",
                api: radioStationDetails,
                playapi: radioStationDetails
            };
            break;


        case 'WRITER':
            resultObject = {
                slug: "writer_slug",
                pagelistApi: writerPageList
            };
            break;
        case 'CATEGORY':
            resultObject = {
                slug: "category_slug",
            };
            break;
        case 'MUSICIAN':
            resultObject = {
                slug: "musician_slug",
                pagelistApi: musicianPageList
            };
            break;

        case 'LANGUAGE':
            resultObject = {
                slug: "language_slug",
            };
            break;
        case 'GENRE':
            resultObject = {
                slug: "audio_genre_slug",
                details: "AudioGenre",
                playlistdetails: "category_Audios",
                artists: "",
                api: musicGenrePlay,
                playapi: musicGenrePlay
            };
            break;
        default:
            throw new Error('Invalid type');
    }
    //console.log(resultObject[chooseobject], 'result')
    return resultObject[chooseobject];
}

const getMusicHomePageAction = () => async (dispatch) => {
    try {
        const response = await axios.post(`${musicHomePageApi}`,
            {
                Login_device_type: "web",
                Login_user_id: parseInt(getItem('user_id'), 10) || null,
                limit: 10, page: 1
            },
            {
                headers: getItemToken('access_token') || {
                    'guestverfiykey': "WebVodWebnexs",
                    'Content-Type': 'application/json',
                }
            }
        );
        const ListRes = response?.data?.Home_page;
        dispatch({ type: "GET_MUSIC_HOMEPAGE", payload: ListRes });

    }
    catch (error) {
        dispatch({ type: "GET_MUSIC_HOMEPAGE_FAILED", payload: error });
    };
}

const MusicViewAllPageAction = (type, api, slug, page, limit, source_name) => async (dispatch) => {
    try {
        const response = await axios.post(`${api}`, {
            Login_user_type: parseInt(getItem('role'), 10) || 9,
            Login_device_type: "web",
            Login_user_id: parseInt(getItem('user_id'), 10) || null,
            limit: limit,
            page: page,
            homepage_source: source_name,
            [apiGenerate(type, "slug")]: slug,
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        })
        const ListRes = response?.data
        dispatch({ type: "GET_MUSIC_VIEWALLPAGE_ACTION", payload: ListRes });
    }
    catch (error) {
        dispatch({ type: "GET_MUSIC_VIEWALLPAGE_FAILED", payload: error });
    };
}

const playQueueAction = (type, slug) => async (dispatch) => {
    try {
        console.log('🎵 PlayQueue API Call:', {
            type,
            slug,
            api: apiGenerate(type, 'playapi'),
            slugParam: apiGenerate(type, 'slug')
        });

        // Special handling for radio stations
        if (type === 'STATION') {
            const response = await axios.post(radioStationDetails, {
                Login_device_type: "web",
                slug: slug,
                Login_user_type: parseInt(getItem('role'), 10) || 9,
                Login_user_id: parseInt(getItem('user_id'), 10) || null,
            }, {
                headers: getItemToken('access_token') || {
                    'guestverfiykey': "WebVodWebnexs",
                    'Content-Type': 'application/json',
                }
            });

            console.log('📻 Radio Station API Response:', response.data);

            if (response.data?.status && response.data?.data) {
                const stationData = response.data.data;
                console.log('🎙️ Fetched radio station data:PRADEEP', stationData);
                // Create playable audio object from radio station data
                // Priority: radio_URL should be the primary playback source
                const playableStation = {
                    id: stationData.id,
                    title: stationData.title || stationData.name,
                    slug: stationData.slug || slug,
                    // Map radio_URL to radio_url for player compatibility
                    radio_url: stationData.radio_URL || stationData.radio_url,
                    radio_URL: stationData.radio_URL, // Keep original field name
                    unified_audio_url: stationData.unified_audio_url,
                    stream_url: stationData.stream_url,
                    embed_url: stationData.embed_url,
                    mp3_url: stationData.mp3_url,
                    aac_audio_url: stationData.aac_audio_url,
                    mp3_audio_upload: stationData.mp3_audio_upload,
                    aac_audio_upload: stationData.aac_audio_upload,
                    audio_url: stationData.audio_url,
                    image_URL: stationData.image_URL || stationData.image,
                    image_url: stationData.image_url || stationData.image,
                    radio_station_player_cover_URL: stationData.radio_station_player_cover_URL,
                    Thumbnail: stationData.Thumbnail,
                    audio_access: stationData.audio_access !== false,
                    duration: 0, // Live stream
                    is_station: true,
                    source_type: 'RADIO', // Mark as radio source
                    category: stationData.category,
                    description: stationData.description,
                    artists: stationData.artists || []
                };

                console.log('🎙️ Created playable radio station:', playableStation);

                dispatch({ type: "GET_AUDIO_SUCCESS", payload: [playableStation] });
                dispatch({ type: "GET_CURRENT_SUCCESS", payload: playableStation });
                dispatch({ type: "GET_CURRENT_PLAYLIST_OR_ALBUM", payload: { id: stationData.id, name: stationData.title, type: 'STATION' } });
                dispatch({ type: "GET_PLAYING_SUCCESS", isPlaying: true });
                dispatch({ type: "GET_CURRENT_INDEX", currentIndex: 0 });
                dispatch({ type: "MINIMIZE_PLAYER", payload: false });
                dispatch({ type: "GET_ACTION_TYPE", payload: 'STATION' }); // Set actionType for radio stations
                return;
            } else {
                toast.error(`Radio station "${slug}" not found or unavailable`);
                return;
            }
        }

        // For other types (not STATION), use the original API call
        const response = await axios.post(`${apiGenerate(type, 'playapi')}`, {
            Login_user_type: parseInt(getItem('role'), 10) || 9,
            Login_device_type: "web",
            Login_user_id: parseInt(getItem('user_id'), 10) || null,
            [apiGenerate(type, 'slug')]: slug,
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        });
        const liveResponse = type === "GENRE" ? response?.data?.[apiGenerate(type, 'details')] : response?.data;

        // Combine Main Audio + Other Audios to ensure we always have a playable list
        let rawList = type === "GENRE" ? liveResponse?.[0]?.[apiGenerate(type, 'playlistdetails')] || [] : liveResponse?.[apiGenerate(type, 'playlistdetails')] || [];
        const mainDetails = type === "GENRE" ? liveResponse?.[apiGenerate(type, 'details')]?.[0] : liveResponse?.[apiGenerate(type, 'details')];

        // If mainDetails is valid, ensure it's in the list
        if (mainDetails && mainDetails.id) {
            const exists = rawList.find(item => Number(item.id) === Number(mainDetails.id));
            if (!exists) {
                // Add main audio to the BEGINNING of the list
                rawList = [mainDetails, ...rawList];
            }
        }

        // Accept any playable URL field: mp3_url, aac_audio_url, uploads, radio_url, unified_audio_url, stream_url, embed_url
        const playableList = rawList.filter(item => (
            item?.mp3_url ||
            item?.aac_audio_url ||
            item?.mp3_audio_upload ||
            item?.aac_audio_upload ||
            item?.radio_url ||
            item?.unified_audio_url ||
            item?.stream_url ||
            item?.embed_url
        ));

        if (playableList.length > 0) {
            dispatch({ type: "GET_AUDIO_SUCCESS", payload: playableList });

            // Find index of the clicked song in the new list
            let playIndex = 0; // Default to first song
            if (mainDetails && mainDetails.id) {
                console.log('🔍 Searching for Main Audio ID:', mainDetails.id, 'in list of:', playableList.map(i => i.id));
                // Convert both to string for robust comparison (API often returns strings vs numbers)
                const foundIndex = playableList.findIndex(item => String(item.id) === String(mainDetails.id));

                if (foundIndex !== -1) {
                    playIndex = foundIndex;
                    console.log('✅ Found Main Audio at index:', playIndex);
                } else {
                    console.warn('⚠️ Main Audio ID not found in playable list, defaulting to index 0');
                }
            }

            dispatch({ type: "GET_CURRENT_SUCCESS", payload: playableList[playIndex] });
            dispatch({ type: "GET_CURRENT_PLAYLIST_OR_ALBUM", payload: type === "GENRE" ? liveResponse : liveResponse?.[apiGenerate(type, 'details')] });
            dispatch({ type: "GET_PLAYING_SUCCESS", isPlaying: true });
            dispatch({ type: "GET_CURRENT_INDEX", currentIndex: playIndex });
            dispatch({ type: "GET_CURRENT_DURATION", isDuration: playableList[playIndex]?.duration });
            dispatch({ type: "MINIMIZE_PLAYER", payload: false });
            // Call musicDetailsUpdate to get interaction data
            if (playableList[playIndex]?.slug) {
                dispatch(musicDetailsUpdate(type === "STATION" ? "STATION" : "AUDIO", playableList[playIndex]?.slug));
            }
            // dispatch({ type: "GET_INTERACT_DATA", payload: playableList[0] });
        } else {
            const Name = liveResponse?.name || liveResponse?.artist_name || liveResponse?.title;
            toast.info(`No playable audio found for ${Name}. The station may have unsupported embed content.`);
        }
    } catch (error) {
        console.error('🚫 API Error Details:', {
            type,
            slug,
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data,
            message: error.message
        });
        toast.error(`Failed to play ${type}: ${error.response?.data?.message || error.message}`);
    }
};


const musicDetailsUpdate = (type, slug) => async (dispatch) => {
    try {
        // Special handling for radio stations
        if (type === 'STATION') {
            const response = await axios.post(radioStationDetails, {
                Login_device_type: "web",
                slug: slug,
                Login_user_type: parseInt(getItem('role'), 10) || 9,
                Login_user_id: parseInt(getItem('user_id'), 10) || null,
            }, {
                headers: getItemToken('access_token') || {
                    'guestverfiykey': "WebVodWebnexs",
                    'Content-Type': 'application/json',
                }
            });

            const stationData = response?.data?.radiostation;
            if (stationData) {
                dispatch({ type: "GET_INTERACT_DATA", payload: stationData });
            }
            return;
        }

        // For other types, use the original API
        const response = await axios.post(`${apiGenerate(type, 'api')}`, {
            Login_user_type: parseInt(getItem('role'), 10) || 9,
            Login_device_type: "web",
            Login_user_id: parseInt(getItem('user_id'), 10) || null,
            [apiGenerate(type, 'slug')]: slug,
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        })
        const ListRes = response?.data?.[apiGenerate(type, 'details')]
        dispatch({ type: "GET_INTERACT_DATA", payload: ListRes });
    }
    catch (error) {
        console.log('musicDetailsUpdate error:', error);
    };
}

const getCurrentAction = (nextIndex, playlistAudio, currentTime) => async (dispatch, getState) => {
    let getPrevState = getState();
    if (getPrevState.id !== playlistAudio?.[nextIndex]?.id) {
        dispatch({
            type: "GET_CURRENT_SUCCESS",
            payload: playlistAudio?.[nextIndex],
        });
        dispatch({
            type: "GET_PLAYING_SUCCESS",
            isPlaying: true,
        });
        dispatch({
            type: "GET_CURRENT_INDEX",
            currentIndex: nextIndex,
        });
        dispatch({
            type: "GET_LYRIC_SUCCESS",
            currentTimes: currentTime || 0,
        });
    }
    else {
        console.log("same id")
    }
};

// const songDetailsAction = (type, slug) => async (dispatch) => {
//     try {
//         const response = await axios.post(`${apiGenerate(type, 'api')}`, {
//             Login_user_type: parseInt(getItem('role'), 10) || 9,
//             Login_device_type: "web",
//             Login_user_id: parseInt(getItem('user_id'), 10) || null,
//             [apiGenerate(type, 'slug')]: slug,
//         }, {
//             headers: getItemToken('access_token') || { 'guestverfiykey': "WebVodWebnexs", 'Content-Type': 'application/json', }
//         })
//         const liveResponse = response?.data;
//         console.log(response?.data,'response');
//         dispatch({
//             type: "GET_SONG_DETAILS_ACTION",
//             payload: type == "GENRE" ? liveResponse?.[apiGenerate(type, 'details')][0] : liveResponse?.[apiGenerate(type, 'details')],
//             TopArtist: liveResponse?.[apiGenerate(type, 'artists')],
//             otherAudios: liveResponse?.other_audios ? liveResponse?.other_audios : liveResponse?.data ? liveResponse?.data : liveResponse?.artist_audios ? liveResponse?.artist_audios : liveResponse?.album_audios ? liveResponse?.album_audios : liveResponse?.AudioGenre[0]?.category__audios,
//             otherPlaylist: liveResponse?.other_playlist ? liveResponse?.other_playlist : liveResponse?.TopAudioAlbum ? liveResponse?.TopAudioAlbum : liveResponse?.other_music_station ? liveResponse?.other_music_station : liveResponse?.Other_AudioGenre 
//         });
//        // console.log(payload)
//     }
//     catch (error) {
//         dispatch({ type: "GET_SONG_DETAILS_ACTION_FAILED", payload: error });
//     };
// }
const songDetailsAction = (type, slug) => async (dispatch) => {
    try {
        const response = await axios.post(`${apiGenerate(type, 'api')}`, {
            Login_user_type: parseInt(getItem('role'), 10) || 9,
            Login_device_type: "web",
            Login_user_id: parseInt(getItem('user_id'), 10) || null,
            [apiGenerate(type, 'slug')]: slug,
        }, {
            headers: getItemToken('access_token') || { 'guestverfiykey': "WebVodWebnexs", 'Content-Type': 'application/json', }
        });

        const liveResponse = response?.data;
        //console.log("API Response:", liveResponse);

        // Extract details
        const details = type === "GENRE"
            ? liveResponse?.[apiGenerate(type, 'details')]?.[0]
            : liveResponse?.[apiGenerate(type, 'details')];

        const topArtist = liveResponse?.[apiGenerate(type, 'artists')];

        const otherAudios =
            liveResponse?.other_audios ||
            liveResponse?.data ||
            liveResponse?.artist_audios ||
            liveResponse?.album_audios ||
            (Array.isArray(liveResponse?.AudioGenre) && liveResponse?.AudioGenre[0]?.category_Audios) ||
            [];

        // Extract `otherPlaylist`
        const otherPlaylist =
            liveResponse?.other_playlist ||
            liveResponse?.TopAudioAlbum ||
            liveResponse?.other_music_station ||
            liveResponse?.Other_AudioGenre ||
            [];

        // console.log("Extracted otherAudios:", otherAudios);
        // console.log("Extracted otherPlaylist:", otherPlaylist);

        dispatch({
            type: "GET_SONG_DETAILS_ACTION",
            payload: details,
            TopArtist: topArtist,
            otherAudios: otherAudios,
            otherPlaylist: otherPlaylist
        });
    }
    catch (error) {
        // console.error("Error fetching song details:", error);
        dispatch({ type: "GET_SONG_DETAILS_ACTION_FAILED", payload: error });
    }
};




export { getMusicHomePageAction, MusicViewAllPageAction, playQueueAction, getCurrentAction, songDetailsAction, musicDetailsUpdate, apiGenerate }